<template>
  <div id="MobileFooter">
    <div class="footer_content">
      <div class="officialStore">
        <div class="title">官方店铺</div>
        <div class="item_name">
          <i class="iconfont icon-tubiaozhizuo-"></i>
          <span @click="goto(1)" style="padding-left: 0.533vw; width: 16.4vw"
            >让茶官方微博
          </span>
          <span> | </span>
          <i class="iconfont icon-tubiaozhizuo-"></i>
          <span @click="goto(2)" style="padding-left: 0.533vw; width: 16.4vw"
            >他山集官方微博</span
          >
          <!--  让茶官方微博 | 他山集官方微博 -->
        </div>
        <div class="item_name">
          <i class="iconfont icon-tianmaot"></i>
          <span @click="goto(6)" style="padding-left: 0.533vw"
            >让茶天猫旗舰店</span
          >
          <span> | </span>
          <i class="iconfont icon-tianmaot"></i>
          <span @click="goto(5)" style="padding-left: 0.533vw"
            >他山集天猫旗舰店</span
          >
        </div>

        <div class="item_name">
          <i class="iconfont icon-jingdong1"></i>
          <span @click="goto(3)" style="padding-left: 0.533vw"
            >让茶京东自营旗舰店</span
          > 
          <!--  让茶京东旗舰店 | 他山集京东旗舰店 -->
        </div>
      </div>
      <div class="concatUs">
        <div class="title">联系我们</div>
        <div class="item_name">
          <i class="iconfont icon-dianhua"></i>
          <!-- <span>  400—807—0177</span> -->
          <a href="tel:400—807—0177">400-807-0177</a>
        </div>
        <div class="item_name">
          <i class="iconfont icon-youxiang"></i>
          <span> hr@rangcha.com</span>
        </div>
      </div>
      <div class="wechat">
        <div class="title">微信公众号</div>
        <div class="content">
          <div class="item">
            <img src="../assets/index/rangcha_qr.jpg" alt="" srcset="" />
            <div>让茶官方</div>
          </div>
          <div class="item">
            <img src="../assets/index/tasantea_qr.jpg" alt="" srcset="" />
            <div>他山集茶官方</div>
          </div>
        </div>
      </div>
    </div>
    <div class="driver"></div>
    <div class="tip" @click="toICP">让茶（北京）饮料有限公司 京ICP备2023008466号-1</div>
  </div>
</template>

<script>
export default {
  name: "MobileFooter",
  components: {},
  props: {},
  setup() {},
  data() {
    return {};
  },
  methods: {
    goto(index) {
      if (index == 1) {
        window.location.href = "https://weibo.com/u/7519768470?is_all=1";
      }
      if (index == 2) {
        window.location.href =
          "https://weibo.com/u/7455891248?refer_flag=1001030103_";
      }
      if (index == 3) {
        window.location.href =
          "https://shop.m.jd.com/?shopId=1000381582&gx=RnFlwmBeO2aPzdRP--twXVB0_FmP924CG1Pk&ad_od=share&utm_source=androidapp&utm_medium=appshare&utm_campaign=t_335139774&utm_term=CopyURL";
      }
      if (index == 4) {
        window.location.href =
          "https://mall.jd.com/index-10224870.html?from=pc";
      }
      if (index == 5) {
        window.location.href =
          "https://tashanjicha.tmall.com/shop/view_shop.htm";
      }
      if (index == 6) {
        window.location.href = "https://rangcha.m.tmall.com";
      }
    },
    toICP(){
      window.open("https://beian.miit.gov.cn/")
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="less">
#MobileFooter {
  width: 100vw;
  height: 26.4vw;
  background: #383838;
  overflow: hidden;
  .footer_content {
    width: 100vw;
    height: calc(100% - 3.6vw - 1.867vw);
    margin: 1.867vw 1.6vw 0 1.6vw;
    display: flex;
    justify-content: space-between;
    overflow: hidden;
    .officialStore {
      width: 54vw;
    }
    .concatUs {
      width: 27vw;
    }
    .officialStore,
    .concatUs {
      .title {
        font-size: 10px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 1.333vw;
      }
      .item_name {
        height: 14px;
        margin-bottom: 0.8vw;
        font-size: 8px;
        font-weight: 400;
        color: #c4c4c4;
        a,
        span {
          font-size: 8px;
          font-weight: 400;
          color: #c4c4c4;
          /* line-height: 2.133vw; */
        }
        & span:nth-child(3) {
          padding: 0 0.8vw;
        }
      }
    }
    .wechat {
      width: 24vw;
      .title {
        font-size: 8px;
        font-weight: 400;
        color: #ffffff;
        margin-bottom: 2.4vw;
      }
      .content {
        margin-top: 2.4vw;
        .item {
          width: 8.667vw;
          float: left;
          img {
            width: 8.667vw;
            height: 8.667vw;
            margin: 0 1vw;
          }
          div {
            width: 100%;
            text-align: center;
            margin-top: 1.467vw;
            font-size: 6px;
            font-weight: 400;
            color: #c4c4c4;
          }
        }
      }
    }
  }
  .driver {
    width: 100%;
    height: 1px;
    background: #ffff;
    opacity: 0.1;
  }
  .tip {
    width: 100%;
    height: 3.467vw;
    font-size: 7px;
    font-weight: 400;
    color: #ffffff;
    line-height: 3.6vw;
    text-align: center;
    opacity: 0.6;
    cursor: pointer;
  }
}
</style>
